var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location Pin 3",
    clipPath: "url(#clip0_22_9879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-pin-3--navigation-map-maps-pin-gps-location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.75 12.5C28.75 20 17.5 28.75 17.5 28.75C17.5 28.75 6.25 20 6.25 12.5C6.25 6.3725 11.3725 1.25 17.5 1.25C23.6275 1.25 28.75 6.3725 28.75 12.5Z",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 16.25C18.4946 16.25 19.4484 15.8549 20.1517 15.1517C20.8549 14.4484 21.25 13.4946 21.25 12.5C21.25 11.5054 20.8549 10.5516 20.1517 9.84835C19.4484 9.14509 18.4946 8.75 17.5 8.75C16.5054 8.75 15.5516 9.14509 14.8483 9.84835C14.1451 10.5516 13.75 11.5054 13.75 12.5C13.75 13.4946 14.1451 14.4484 14.8483 15.1517C15.5516 15.8549 16.5054 16.25 17.5 16.25Z",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.6925 25H30L33.75 33.75H1.25L5 25H7.3075",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_9879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.d0cf5351dc1060005cff2208d07192f6.svg";
export { ForwardRef as ReactComponent };